<ng-container *ngIf="allCategoryKeys.length >= maxCategoriesForPolarChart; else polarChartTemplate">
  <dx-chart
    class="matrix-chart"
    [dataSource]="personCompetencyMatrixData"
  >
    <dxi-series
      type="line"
      argumentField="categoryKey"
      valueField="countOfCompletedEvents"
    >
    </dxi-series>

    <dxo-argument-axis>
      <dxo-label
        [visible]="true"
        [overlappingBehavior]="'rotate'"
        [rotationAngle]="allCategoryKeys.length >= maxCategoriesForInclineLabels ? 90 : 45"
        [customizeText]="customizeCategoryLabel"
        [customizeHint]="customizeCategoryHint"
      >
      </dxo-label>
    </dxo-argument-axis>

    <dxo-tooltip
      [enabled]="true"
      [customizeTooltip]="customizeTooltip"
    ></dxo-tooltip>

    <dxo-legend [visible]="false"></dxo-legend>
  </dx-chart>
</ng-container>

<ng-template #polarChartTemplate>
  <dx-polar-chart
    class="matrix-chart"
    [dataSource]="personCompetencyMatrixData"
    [useSpiderWeb]="true"
  >
    <dxi-series
      type="line"
      argumentField="categoryKey"
      valueField="countOfCompletedEvents"
    >
    </dxi-series>

    <dxo-common-series-settings type="line"></dxo-common-series-settings>

    <dxo-argument-axis [categories]="allCategoryKeys">
      <dxo-label
        [visible]="true"
        [overlappingBehavior]="'none'"
        [customizeText]="customizeCategoryLabel"
        [customizeHint]="customizeCategoryHint"
      >
      </dxo-label>
    </dxo-argument-axis>

    <dxo-tooltip
      [enabled]="true"
      [customizeTooltip]="customizeTooltip"
    ></dxo-tooltip>

    <dxo-legend [visible]="false"></dxo-legend>
  </dx-polar-chart>
</ng-template>